import { VscSignOut } from "react-icons/vsc";
import { useEffect, useRef, useState } from "react";
import { userServices } from "../APIServices/userServices";
import { Button, Collapse, ListGroup } from "react-bootstrap";
import {
  RiArrowDownWideLine,
  RiArrowRightWideFill,
  RiProfileLine,
} from "react-icons/ri";
import User from "../Img/user.png";
import { FiHome } from "react-icons/fi";
import { TbPlugConnected } from "react-icons/tb";
import { FaRoadBridge } from "react-icons/fa6";
import { PiVaultLight } from "react-icons/pi";
import { useParams } from "react-router-dom";

const AdminHeader = ({
  getCurrectLoginUser,
  currentUserData,
  setActiveItem,
}) => {
  const { app } = useParams()
  const [openProfile, setOpenProfile] = useState(false);
  const [switchAccount, setSwitchAccount] = useState(false);
  const AppsRef = useRef(null);
  const AccountRef = useRef(null);

  const logout = async () => {
    await userServices.logout();
  };

  useEffect(() => {
    getCurrectLoginUser();
    const handleClickOutside = (event) => {
      if (AppsRef.current && !AppsRef.current.contains(event.target)) {
        setOpenProfile(false);
      }
      if (AccountRef.current && !AccountRef.current.contains(event.target)) {
        setSwitchAccount(false);
      }
    };
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, []);

  return (
    <header
      className="hstack justify-content-end bg-white border-bottom px-3"
      style={{ height: 55 }}
    >
      <div className="hstack gap-2">
        {app &&
          <div className="position-relative" ref={AccountRef}>
            <Button
              variant="light"
              className={`profile-btn py-2 px-3 ${switchAccount ? "active" : ""}`}
              onClick={() => setSwitchAccount(!switchAccount)}
              title={`Switch Account`}
            >
              <span>Switch Account</span>
              {switchAccount ? <RiArrowDownWideLine /> : <RiArrowRightWideFill />}
            </Button>

            <Collapse in={switchAccount}>
              <div className="profile-dropdown">
                <ListGroup variant="flush">
                  <ListGroup.Item
                    action
                    href="/home"
                    className="hstack gap-2"
                    style={{ fontSize: 12 }}
                  >
                    <FiHome />
                    Home
                  </ListGroup.Item>

                  <ListGroup.Item
                    action
                    className="hstack gap-2"
                    style={{ fontSize: 12 }}
                    href="/home/vaults"
                  >
                    <PiVaultLight />
                    Vault Management
                  </ListGroup.Item>
                  <ListGroup.Item
                    action
                    className="hstack gap-2"
                    style={{ fontSize: 12 }}
                    href="/home/sitePilot"
                  >
                    <TbPlugConnected />
                    Site Pilot Management
                  </ListGroup.Item>
                  <ListGroup.Item
                    action
                    className="hstack gap-2"
                    href="/home/workBridge"
                    style={{ fontSize: 12 }}
                  >
                    <FaRoadBridge />
                    Work Bridge
                  </ListGroup.Item>
                </ListGroup>
              </div>
            </Collapse>
          </div>
        }
        <div className="position-relative" ref={AppsRef}>
          <Button
            variant="light"
            className={`profile-btn ${openProfile ? "active" : ""}`}
            onClick={() => setOpenProfile(!openProfile)}
            title={currentUserData?.name}
          >
            <img
              src={User}
              alt="User"
              className="rounded-circle"
              style={{ width: 28, height: 28 }}
            />
            <span>{currentUserData?.name}</span>
            {openProfile ? <RiArrowDownWideLine /> : <RiArrowRightWideFill />}
          </Button>

          <Collapse in={openProfile}>
            <div className="profile-dropdown">
              <ListGroup variant="flush">
                <ListGroup.Item
                  action
                  className="hstack gap-2"
                  style={{ fontSize: 12 }}
                  onClick={() => {
                    setActiveItem("manageAccount");
                    setOpenProfile(false);
                  }}
                >
                  <RiProfileLine />
                  Manage Account
                </ListGroup.Item>

                <ListGroup.Item
                  action
                  className="hstack gap-2 text-danger"
                  style={{ fontSize: 12 }}
                  onClick={logout}
                >
                  <VscSignOut />
                  Sign Out
                </ListGroup.Item>
              </ListGroup>
            </div>
          </Collapse>
        </div>
      </div>
    </header>
  );
};

export default AdminHeader;
